import _ from 'lodash'

export default {
	get: state => {
		return state.welcomePageFrom
	},
}
